// src/components/common/ConfirmDialog.jsx
import React from 'react';
import Modal from './Modal';

const ConfirmDialog = ({ isOpen, onClose, onConfirm, title = 'Confirm', message, danger = false }) => (
  <Modal
    isOpen={isOpen}
    onClose={onClose}
    title={title}
    size="sm"
    footer={
      <>
        <button className="btn btn-secondary" onClick={onClose}>Cancel</button>
        <button className={`btn ${danger ? 'btn-danger' : 'btn-primary'}`} onClick={() => { onConfirm(); onClose(); }}>
          Confirm
        </button>
      </>
    }
  >
    <p style={{ color: 'var(--gray-600)', lineHeight: 1.6 }}>{message}</p>
  </Modal>
);

export default ConfirmDialog;
